// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/1792058191362/js/" + (chunkId === 988 ? "vendor-mantine" : chunkId) + ".chunk.js";
};